import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ArrowPopover as Tooltip } from '@alfa-bank/site-popover/arrow-popover';

import { Hint as Component } from '../hint';
import type { THint, IDeps } from '../models';
import { Icon } from '../hint-icon';
import styles from '../styles/styles.css';

export const HintDesktop = createWidget<IDeps, THint>({
    Icon,
    Tooltip,
    styles,
})(Component);
